exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-content__content[data-v-32a633d8] {\n  margin-bottom: 2px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n", ""]);

// exports
